/**
 * Cuts a label to a specified length and adds ellipsis if needed
 * @param {string|Array} label - The label to cut (can be a string or array of strings)
 * @param {number} maxLength - Maximum length before cutting (default: 10)
 * @param {number} visibleChars - Number of visible characters before ellipsis (default: 10)
 * @returns {string|Array} The cut label with ellipsis if needed
 */
export const cutLabel = (label, maxLength = 10, visibleChars = 10) => {
  if (visibleChars < 3) {
    visibleChars = 0
  }

  if (Array.isArray(label)) {
    return label.map((item) =>
      typeof item === "string" && item.length > maxLength
        ? `${item.slice(0, visibleChars)}...`
        : item
    )
  }

  return typeof label === "string" && label.length > maxLength
    ? `${label.slice(0, visibleChars)}...`
    : label
}
